import { ReactNode } from 'react'
import { usePageTitle } from '@/utils/hooks/usePageTitle'

interface MinimalLayoutProps {
  children: ReactNode
  title?: string
}

export const MinimalLayout = ({ children, title }: MinimalLayoutProps) => {
  usePageTitle(title)
  return <div className="h-full w-full">{children}</div>
}
